$(document).ready(function(){
  var t;
  var _suppressSearch = false;

  function buildSearchParams() {
    var params = new URLSearchParams();

    var searchValue = $("#auction_search").val();
    if (searchValue && searchValue.trim() !== '') {
      params.set('search', searchValue.trim());
    }

    var checked = [];
    $("input[name='category_search[]']:checked").each(function() {
      checked.push($(this).val());
    });
    if (checked.length > 0) {
      checked.forEach(function(category) {
        params.append('category_search[]', category);
      });
    } else {
      // Must send the key when nothing is checked; otherwise assign_public_listing_filters! keeps
      // session[:auction_category_search] and auction_filter.js re-renders facets with the old box checked.
      params.append('category_search[]', '');
    }

    var locations = $("#auction_locations").val();
    var locList = [];
    if (locations) {
      if (Array.isArray(locations)) {
        locList = locations.filter(function(l) { return l && String(l).trim() !== ''; });
      } else if (String(locations).trim() !== '') {
        locList = [locations];
      }
    }
    if (locList.length > 0) {
      locList.forEach(function(location) {
        params.append('auction_locations[]', location);
      });
    } else {
      // Same as categories: omitting the key leaves session[:auction_locations] stale and Helsinki returns.
      params.append('auction_locations[]', '');
    }

    return params;
  }

  function updateURL() {
    var params = buildSearchParams();
    params.set('active_search', $("#active_search").val() || 'true');

    var newURL = window.location.pathname;
    // URLSearchParams encodes spaces as '+', but Facebook's redirect layer (l.facebook.com/l.php)
    // percent-encodes '+' to '%2B' when wrapping the URL. The browser then decodes '%2B' as a
    // literal '+', so Rails receives "konkurssikaupat+suomi" (not a space) and the search fails.
    // Using '%20' for spaces is unambiguous across all URL processors.
    var queryString = params.toString().replace(/\+/g, '%20');
    if (queryString) {
      newURL += '?' + queryString;
    }

    try {
      window.history.pushState({path: newURL}, '', newURL);
      setTimeout(function() {
        var currentURL = window.location.pathname + window.location.search;
        if (currentURL !== newURL) {
          window.history.replaceState({path: newURL}, '', newURL);
        }
      }, 50);
    } catch(e) {
      window.history.replaceState({path: newURL}, '', newURL);
    }
  }

  function populateFiltersFromURL(suppressSearch) {
    if (suppressSearch) {
      _suppressSearch = true;
      setTimeout(function() { _suppressSearch = false; }, 250);
    }
    var urlParams = new URLSearchParams(window.location.search);

    var searchParam = urlParams.get('search');
    if (searchParam) {
      $("#auction_search").val(searchParam);
    }

    var categoryParams = urlParams.getAll('category_search[]').filter(function(p) { return p && String(p).trim() !== ''; });
    if (categoryParams.length > 0) {
      $("input[name='category_search[]']").prop('checked', false);
      categoryParams.forEach(function(category) {
        var escapedCategory = category.replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, "\\$&");
        $("input[name='category_search[]'][value='" + escapedCategory + "']").prop('checked', true);
      });
    } else {
      $("input[name='category_search[]']").prop('checked', false);
    }

    var locationParams = urlParams.getAll('auction_locations[]').filter(function(p) { return p && String(p).trim() !== ''; });
    if (locationParams.length > 0) {
      $("#auction_locations").val(locationParams).trigger('change');
      if (typeof reinitializeSelect2 === 'function') {
        setTimeout(function() {
          reinitializeSelect2();
          $("#auction_locations").val(locationParams).trigger('change');
        }, 100);
      }
    } else if ($("#auction_locations").length) {
      $("#auction_locations").val(null).trigger('change');
      if (typeof reinitializeSelect2 === 'function') {
        setTimeout(function() {
          reinitializeSelect2();
          $("#auction_locations").val(null).trigger('change');
        }, 100);
      }
    }
  }

  populateFiltersFromURL(true);

  window.addEventListener('popstate', function(event) {
    var returningFromAd = false;
    try { returningFromAd = !!sessionStorage.getItem('scrollPosition'); } catch(e) {}

    if (returningFromAd) {
      _suppressSearch = true;
      populateFiltersFromURL();
      setTimeout(function() { _suppressSearch = false; }, 2000);
      return;
    }

    populateFiltersFromURL();
    if (window.performAuctionSearch) {
      window.performAuctionSearch();
    }
  });

  $(document).on('click', '#pills-auction-announcement-tab',  function() {
    second_pagination();
  });

  $(document).on('click', '#pills-notice-sale-tab',  function() {
    third_pagination();
  });

  $(document).on("click", ".online-auction-btn", function(){
    $('.online_auctions_categories').removeClass('hide');
    $('.auction_notices_categories').addClass('hide');
    $('.sale_ads_categories').addClass('hide');
  });

  $(document).on("click", ".auction-notice-btn", function(){
    $('.online_auctions_categories').addClass('hide');
    $('.auction_notices_categories').removeClass('hide');
    $('.sale_ads_categories').addClass('hide');
  });

  $(document).on("click", ".sales-ad-btn", function(){
    $('.online_auctions_categories').addClass('hide');
    $('.auction_notices_categories').addClass('hide');
    $('.sale_ads_categories').removeClass('hide');
  });

  $(document).on('click', '.active_search, .end_search', function() {
    var $btn = $(this);
    if ($btn.hasClass('end_search')) {
      $('#active_search').val('false');
      $('.active_search').removeClass('btn-primary');
      $('.end_search').addClass('btn-primary');
    } else {
      $('#active_search').val('true');
      $('.end_search').removeClass('btn-primary');
      $('.active_search').addClass('btn-primary');
    }
    performAuctionSearch();
  });

  $(document).on("keyup", "#auction_offer", function() {
    var offerValue = $("#auction_offer").val().trim();
    var verify_identification_status = $("#verify_identification_status").val();

    var normalized = offerValue.replace(',', '.');
    var isNumber = !isNaN(normalized);
    var isWhole = (parseFloat(normalized) % 1 === 0);

    if (offerValue && verify_identification_status === "true") {
      $(".auction_offer_button").removeClass("disableattchmentbutton");
    } else {
      $(".auction_offer_button").addClass("disableattchmentbutton");
    }
  });


  function performAuctionSearch() {
    if (_suppressSearch) return;
    if (window._scrollRestoreActive) return;
    var checked = []
    $("input[name='category_search[]']:checked").each(function ()
    {
        checked.push($(this).val());
    });
    clearTimeout(t);
    t = setTimeout(function () {
      if ($("#loader-image").length) {
        $("#loader-image").show();
      }

      var params = buildSearchParams();
      params.set('search', ($("#auction_search").val() || '').trim());
      params.set('active_search', $("#active_search").val() || 'true');
      params.set('filter', 'true');
      params.delete('page');

      updateURL();

      $.ajax({
        url: '/search/auction_filter?' + params.toString(),
        type: 'GET',
        dataType: 'script',
        success: function() {
          setTimeout(function() {
            if (typeof updateURL === 'function') {
              updateURL();
            }
          }, 100);
        }
      });
    }, 500);
  }

  window.performAuctionSearch = performAuctionSearch;
  window.updateURL = updateURL;

  var enterKeyPressed = false;

  $(document).on('keypress', '#auction_search', function(e) {
    if (e.which === 13 || e.keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
      enterKeyPressed = true;
      clearTimeout(t);
      updateURL();
      performAuctionSearch();
      setTimeout(function() {
        enterKeyPressed = false;
      }, 100);
    }
  });

  $(document).on('keyup', '#auction_search', function(e) {
    if (e.which === 13 || e.keyCode === 13 || enterKeyPressed) {
      return;
    }
    setTimeout(function() {
      updateURL();
    }, 10);
    performAuctionSearch();
  });

  $(document).on('change', 'input[name="category_search[]"]', function() {
    updateURL();
    performAuctionSearch();
  });

  $(document).on('change', '#auction_locations', function() {
    if (_suppressSearch) return;
    if (window._scrollRestoreActive) return;
    updateURL();
    performAuctionSearch();
  });

  $(document).on("click", "#pills-online-auction-tab", function(){
    $(".online_auction_section").removeClass("hide");
    $(".auction_notice_section").addClass("hide");
    $(".sales_ad_section").addClass("hide");
  });

  $(document).on("click", "#pills-auction-announcement-tab", function(){
    $(".online_auction_section").addClass("hide");
    $(".auction_notice_section").removeClass("hide");
    $(".sales_ad_section").addClass("hide");
  });

  $(document).on("click", "#pills-notice-sale-tab", function(){
    $(".online_auction_section").addClass("hide");
    $(".auction_notice_section").addClass("hide");
    $(".sales_ad_section").removeClass("hide");
  });

  if ($('.pagination').length) {
    $(document).off('scroll.firstPagination').on('scroll.firstPagination', function() {
      var $pane = $('#pills-online-auction');
      if (!$pane.length || !$pane.hasClass('show')) return;
      var $link = $('.pagination .next_page');
      var url = $link.attr('href');
      if (url && !$link.data('loading') && $(window).scrollTop() + $(window).height() >= $(document).height() - 200) {
        $link.data('loading', true);
        $('.pagination').text("Pieni hetki...");
        return $.getScript(url);
      }
    });
  }

  // Scroll auto-load for the three custom pagination containers.
  // Uses the same jQuery event namespaces as auction_filter.js.erb so that file's
  // .off().on() calls simply replace these handlers on each filter AJAX response.
  // Registering here ensures infinite scroll works from the very first page load
  // and survives back-navigation (Turbolinks preserves $(document) listeners).
  if ($('#pills-online-auction, .first_pagination').length) {
    $(document).off('scroll.first_pagination').on('scroll.first_pagination', function() {
      if (window._scrollRestoreActive) return;
      var $nextLink = $('.first_pagination .next_page');
      if (!$nextLink.length) return;
      var $pane = $nextLink.closest('.tab-pane');
      if ($pane.length ? !$pane.hasClass('show') : ($('#pills-online-auction').length && !$('#pills-online-auction').hasClass('show'))) return;
      var url = $nextLink.attr('href');
      if (url && !$nextLink.data('loading') && $(window).scrollTop() + $(window).height() > $(document).height() - 400) {
        $nextLink.data('loading', true);
        $('.first_pagination').html("Pieni hetki...");
        $.getScript(url + (url.indexOf('?') > -1 ? '&' : '?') + 'loading_tab=online');
      }
    });

    $(document).off('scroll.second_pagination').on('scroll.second_pagination', function() {
      if (window._scrollRestoreActive) return;
      var $nextLink = $('.second_pagination .next_page');
      if (!$nextLink.length) return;
      var $pane = $nextLink.closest('.tab-pane');
      if ($pane.length ? !$pane.hasClass('show') : ($('#pills-auction-announcement').length && !$('#pills-auction-announcement').hasClass('show'))) return;
      var url = $nextLink.attr('href');
      if (url && !$nextLink.data('loading') && $(window).scrollTop() + $(window).height() > $(document).height() - 400) {
        $nextLink.data('loading', true);
        $('.second_pagination').html("Pieni hetki...");
        $.getScript(url + (url.indexOf('?') > -1 ? '&' : '?') + 'loading_tab=announcement');
      }
    });

    $(document).off('scroll.third_pagination').on('scroll.third_pagination', function() {
      if (window._scrollRestoreActive) return;
      var $nextLink = $('.third_pagination .next_page');
      if (!$nextLink.length) return;
      var $pane = $nextLink.closest('.tab-pane');
      if ($pane.length ? !$pane.hasClass('show') : ($('#pills-notice-sale').length && !$('#pills-notice-sale').hasClass('show'))) return;
      var url = $nextLink.attr('href');
      if (url && !$nextLink.data('loading') && $(window).scrollTop() + $(window).height() > $(document).height() - 400) {
        $nextLink.data('loading', true);
        $('.third_pagination').html("Pieni hetki...");
        $.getScript(url + (url.indexOf('?') > -1 ? '&' : '?') + 'loading_tab=sale');
      }
    });
  }

  $(document).on("click", ".view-more-link", function(){
    $('.view-less').removeClass('hide');
    $('.view-more').addClass('hide');
    $('.view-more-info').removeClass('hide');
  });

  $(document).on("click", ".view-less-link", function(){
    $('.view-less').addClass('hide');
    $('.view-more').removeClass('hide');
    $('.view-more-info').addClass('hide');
  });
});


function second_pagination(){
  if ($('.second_pagination').length) {
    $(document).off('scroll.secondPagination').on('scroll.secondPagination', function() {
      var $pane = $('#pills-auction-announcement');
      if (!$pane.length || !$pane.hasClass('show')) return;
      var $link = $('.second_pagination .next_page');
      var url = $link.attr('href');
      if (url && !$link.data('loading') && $(window).scrollTop() + $(window).height() >= $(document).height() - 200) {
        $link.data('loading', true);
        $('.second_pagination').text("Pieni hetki...");
        return $.getScript(url);
      }
    });
  }
}

function third_pagination(){
  if ($('.third_pagination').length) {
    $(document).off('scroll.thirdPagination').on('scroll.thirdPagination', function() {
      var $pane = $('#pills-notice-sale');
      if (!$pane.length || !$pane.hasClass('show')) return;
      var $link = $('.third_pagination .next_page');
      var url = $link.attr('href');
      if (url && !$link.data('loading') && $(window).scrollTop() + $(window).height() >= $(document).height() - 200) {
        $link.data('loading', true);
        $('.third_pagination').text("Pieni hetki...");
        return $.getScript(url);
      }
    });
  }
}

